import { asNumber, asRecord, asString, assertArray } from "@/data/mapper/common/mapper-utils";
import { TreatmentSummaryEntity } from "@/domain/entity/treatment/treatment-summary-entity";

export class TreatmentSummaryMapper {
  static toEntity(dto: unknown): TreatmentSummaryEntity {
    const map = asRecord(dto);
    const doctor = asRecord(map.doctor);
    const doctorName =
      map.doctorName == null && map.medicalExpertName == null && doctor.name == null
        ? null
        : asString(map.doctorName ?? map.medicalExpertName ?? doctor.name);
    return {
      treatmentUuid: asString(map.treatmentUuid ?? map.uuid ?? map.prescriptionUuid),
      treatmentId:
        map.treatmentId == null && map.prescriptionId == null
          ? null
          : asString(map.treatmentId ?? map.prescriptionId),
      status:
        map.status == null &&
        map.state == null &&
        map.progressStatus == null &&
        map.treatmentStatus == null &&
        map.treatmentState == null
          ? null
          : asString(
              map.status ??
                map.state ??
                map.progressStatus ??
                map.treatmentStatus ??
                map.treatmentState,
            ),
      startDate: map.startDate == null ? null : asString(map.startDate),
      endDate: map.endDate == null ? null : asString(map.endDate),
      type: map.type == null ? null : asString(map.type),
      step: map.step == null ? null : asNumber(map.step),
      complianceRate: map.complianceRate == null ? null : asNumber(map.complianceRate),
      progressPercent: map.progressPercent == null ? null : asNumber(map.progressPercent),
      ...(doctorName == null ? {} : { doctorName }),
    };
  }

  static toEntityList(dto: unknown): TreatmentSummaryEntity[] {
    return assertArray(dto, "TreatmentSummaryMapper::toEntityList").map((item) =>
      TreatmentSummaryMapper.toEntity(item),
    );
  }
}
